import { createAction } from "redux-starter-kit";
import { deleteRow } from "../../entities";
import { DELETE_REASON_FOR_LEAVING_REQUEST } from "../types";

const deleteReasonForLeaving = id => async (
  dispatch,
  getState,
  { api, schema }
) => {
  const response = await api.factoring.deleteReasonForLeaving(id);
  dispatch(
    createAction(DELETE_REASON_FOR_LEAVING_REQUEST)({
      id
    })
  );
  dispatch(deleteRow({ entity: "reasonForLeaving", id }));
  return response;
};

export default deleteReasonForLeaving;
